import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

const GET_MOOD_BOARD = gql`
  query GetDesignBoard($designBoardId: ID!) {
    getDesignBoard(designBoardId: $designBoardId) {
      _id
      name
      type
      description
      why
      designerId
      color
      texture
      finish
      pattern
      roomType
      greatFor
      published
      images {
        _id
        name
        path
        url
        title
        credit
        description
      }
    }
  }
`;

export const useGetMoodBoardQuery = () => {
  const [getMoodBoardQuery, { loading, data }] = useLazyQuery(GET_MOOD_BOARD);

  const getMoodBoard = useCallback(async (
    designBoardId: string,
    refresh: boolean = false
  ) => {
    const result = await getMoodBoardQuery({
      variables: {
        designBoardId,
      },
      fetchPolicy: refresh ? "network-only" : "cache-first",
    });
    return result?.data?.getDesignBoard;
  }, [getMoodBoardQuery]);

  const moodBoard = data?.getDesignBoard;

  return {
    getMoodBoard,
    loading,
    moodBoard,
  };
};
